/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import { CookiesProvider } from 'react-cookie';

import './src/styles/global.scss';

import { SearchProvider } from './src/context/SearchProvider';

export const wrapRootElement = ({ element }) => (
  <CookiesProvider>
    <SearchProvider>{element}</SearchProvider>
  </CookiesProvider>
);
